import { ResultRecord } from "@rsm-hcd/javascript-core";
import CitationItemRecord from "models/view-models/citations/citation-item-record";
import CitationsService from "utilities/services/citations/citations-service";

export enum CitationTokenError {
    MissingToken = "MISSING_TOKEN",
    ExpiredToken = "EXPIRED_TOKEN",
    InvalidToken = "INVALID_TOKEN",
}
type CitationTokenErrorType = CitationTokenError | string | undefined;

interface UseCitationsTokenResponse {
    citations: CitationItemRecord[];
    hasError: boolean;
    error: CitationTokenErrorType;
    isLoading: boolean;
}

const useCitationsToken = (
    token: string | null | undefined
): UseCitationsTokenResponse => {
    const isMissingToken = token == null;

    const { list } = CitationsService.useListQuery();

    const { isLoading, data, isError, error } = list(
        { token },
        {
            enabled: !isMissingToken,
        }
    );

    return {
        citations: data?.resultObjects ?? [],
        hasError: isMissingToken || isError,
        error: isMissingToken
            ? CitationTokenError.MissingToken
            : parseError(error),
        isLoading: isMissingToken ? false : isLoading,
    };
};

export default useCitationsToken;

const parseError = (err: unknown): CitationTokenErrorType => {
    if (err instanceof ResultRecord) {
        return err.errors?.at(0)?.key;
    }

    if (err == null) {
        return undefined;
    }

    console.error(
        "Unexpected error type when fetching citations with token",
        err
    );
    return String(err);
};
